import { render, staticRenderFns } from "./PayMix.vue?vue&type=template&id=e87a7b38&scoped=true&"
import script from "./PayMix.vue?vue&type=script&lang=js&"
export * from "./PayMix.vue?vue&type=script&lang=js&"
import style0 from "./PayMix.vue?vue&type=style&index=0&id=e87a7b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a7b38",
  null
  
)

export default component.exports